import {QueryCommand} from "xmgoing-server";
import SysConfigUtils from "@/utils/sysConfigUtils";
import {AssertUtils} from 'xmgoing-utils';
import StyleUtils from "@/gateway-main/common/styleUtils";
import i18n from "@/i18n";
import {getCurrentYear, getPreYear} from "xmgoing-utils";
import {initErrorDealStr, initParamsByParamsDealStr, initSuccessDealDealStr} from "@/store/utils/dataSourceUtils";
import {getFieldQueryScopeSetting} from "@/gateway-main/common/dataSccpeSettingUtils";


const PlatformPrefix = SysConfigUtils.go_eplat_adress;

/**
 * 获取控件的高度信息
 * @param borderConfig
 */
export function getCtlBodyHeight(borderConfig){
  let height = borderConfig.value.height;
  height = (height + "").replace("px", "");
  if (AssertUtils.isNumber(height)) {
    height = parseFloat(StyleUtils.getPxNumber(height));
  }
  return height;
}


/**
 * 对查询条件和参数进行处理
 * @param dataConfig
 * @param filterStr
 */
const initQueryParams=function ({dataConfig,filterStr}){
  const {domainCode,xPointIds,yColumns,xPointLabels,queryScope,queryScopeSettings}=unref(dataConfig);
  const metrics:any=[];
  if(yColumns&&Array.isArray(yColumns)){
    yColumns.forEach((itemDb)=>{
      metrics.push(
        {
          "columnKey": itemDb.propId, //统计纬度1数据之和
          "columnName": itemDb.propName,
          "op": itemDb.sumType
        }
      )
    });
  }

  const fields:any=[];
  xPointIds&&xPointIds.forEach&&xPointIds.forEach((propId,index)=>{
    const fieldObj:any={
      "columnKey": propId, //统计纬度1数据之和
      "columnName": xPointLabels[index]
    };
    fields.push(fieldObj)
  });
  const params:any={
    "tableCode": domainCode,
    filterStr:JSON.stringify(filterStr),
    scopeSetting:queryScope?queryScopeSettings:{},
    "widget": {
      "fields":[...fields],
      "metrics": [...metrics]
    }
  }
  if(params.filterStr==="{}"){
    delete params.filterStr;
  }
  if(typeof(params.scopeSetting)==="string"){
    params.scopeSetting={};
  }
  return params;
}

const dataTableUtils = {
  //加载报表数据信息
   loadCharData({inParams,dataConfig,filterStr},backFun,flushFlag=false,flushBackFun=function (){}){
    const {useQueryUrl,useQueryType}=unref(dataConfig);
    let params=initQueryParams({dataConfig:unref(dataConfig),filterStr:unref(filterStr)});
     //如果存在处理前的函数
     if (unref(dataConfig).paramsDeal) {
       try{
         const backParams = initParamsByParamsDealStr(params, unref(dataConfig).paramsDeal);
         if (backParams != null && typeof (backParams) === 'object') {
           //将返回回来的参数 给查询使用
           params = backParams;
         }
       }catch (e){
         console.error(e);
       }
     }
     //如果存在指标 才执行
     if((params.widget.metrics&&params.widget.metrics.length>0)||flushFlag||unref(dataConfig).userDefUrl){
       if(params.scopeSetting==null){
         params.scopeSetting={};
       }
       //如果存在inParams
       if(unref(inParams)&&typeof inParams==='object'){
         Object.keys(inParams).forEach((propName)=>{
           params[propName]=inParams[propName];
         })
       }
       //如果是get请求
       if((useQueryType+'').toLowerCase()==='get'){
         Object.keys(params).forEach((propName)=>{
           if(typeof params[propName]==='object'){
             delete params[propName];
           }
         })
       }
       const queryCommand=new QueryCommand({showTip:false,url:useQueryUrl?useQueryUrl:PlatformPrefix+`/api/go-lcc/statistics/statisticsData`,method:useQueryType||'POST'});
       queryCommand.executeQueryPromise({page:false,params}).then((des)=>{
         if (unref(dataConfig).successDeal) {
           const backRes = initSuccessDealDealStr(des, unref(dataConfig).successDeal);
           if (backRes != null && typeof (backRes) === 'object') {
             //将返回回来的参数 给查询使用
             des = backRes;
           }
         }
         backFun&&backFun(des);
         flushBackFun&&flushBackFun(des);
       }, (error) => {
         if (unref(dataConfig).errorDeal) {
           initErrorDealStr(error, unref(dataConfig).errorDeal);
         }
       })
     }
  },
  /**
   * 加载数据
   * @param dataConfig
   * @param current
   * @param pageSize
   * @param successFun
   */
  loadData({extendCondition={},dataConfig,current,pageSize,formula},successFun){
    if(!dataConfig.value.url){
      successFun&&successFun();
      return;
    }
    const params:any={size:pageSize,current,...extendCondition,formula};
    if(formula==null||formula==='{}'){
      delete  params.formula;
    }
    const queryCommand=new QueryCommand({showTip:false,url:PlatformPrefix+`${dataConfig.value.url}`,method:'POST'});
    queryCommand.executeQuery({page:false,params,successFun})
  },
  getSystemDefDatas(){
    return [
      {},
      {}
    ]
  },
  getSystemDefColumns() {
    return [
      {
        title: i18n.global.t('列1'),
        dataIndex: 'fieldnpnegCkuy',
        key: 'fieldnpnegCkuy',
      },
      {
        title: i18n.global.t('列2'),
        dataIndex: 'fieldnpnegGfvk',
        key: 'fieldnpnegGfvk',
      }
    ]
  }
}

export {dataTableUtils};

